export default __webpack_public_path__ + "static/media/welcom.4cde991a.jpg";